/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
// import { SALARY_REPORT_STATE } from "./salary-report-constant";
import { BANK_DISBURSMENT_REPORT_STATE } from "./bank-disbursment-report-constant";
const useBankDisbursmentReportService = () => {
    const [salaryReportTableUILoading, setSalaryReportTableUILoading] = useState(false);
    const [bankReportListData, setBankReportListData] = useState([]);
    const [bankReportPDFData, setBankReportPDFData] = useState([]);
    const [bankReportSummary, setBankReportSummary] = useState({})
    const [bankReportFullData, setBankReportFullData] = useState({})
    const [organizationInfo, setOrganizationInfo] = useState({})
    const { fetchData } = useAPIHandler()
    const [allowances, setAllowances] = useState([])
    const [bankReportInputs, setBankReportInputs] = useState(BANK_DISBURSMENT_REPORT_STATE)
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("")
    const currentRoute = location.pathname.split('/').pop();
    const [loadingAllSalaryReport, setLoadingAllSalaryReport] = useState(false);
		const [dataFetched, setDataFetched] = useState(false);
    const [departmentLists,setDepartmentLists] = useState([])
    const [deptId, setDeptId] = useState('')
    const [totalEmployee, setTotalEmployee] = useState(0)
    const [paymentThrough, setPaymentThrough] = useState('')

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }
        setBankReportInputs((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }))
    }
    const extractAllowances = (data) => {
        const allAllowances = data.reduce((acc, salary) => {
            salary.allowance.forEach(allowance => {
                if (!acc.includes(allowance.allowance_name)) {
                    acc.push(allowance.allowance_name);
                }
            });
            return acc;
        }, []);
        setAllowances(allAllowances)
    }
    const { report_month } = bankReportInputs;
    let year, month
    if (report_month) {
        const parts = report_month.split("-");
        year = parts[0];
        month = parts[1];
        if (month.startsWith("0")) {
            month = month.substring(1);
        }
    }
    logger.log(year,month, "year-month")
    const fetchAllBankReportEmpList = async () => {
        setSalaryReportTableUILoading(true);
        try {
            if (report_month) {
                // const url = currentRoute === "salary-wages-report" ? `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`
                //     :
                //     currentRoute === "salary-report" ? `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&salary_type=salary`
                //         :
                //         currentRoute === "wages-report" ? `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&salary_type=wages`
                //             :
                //             `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`

                // const url= `/report/bank_details?year=${year}&month=${month}&page=${currentPage+1}&limit=${rowsPerPage}&search=${searchQuery}&filter=IMPS`
                const url= `/report/bank_details?year=${year}&month=${month}&page=${currentPage+1}&limit=${rowsPerPage}&search=${searchQuery}`

                const response = await fetchData({
                    url: url,
                    method: 'GET',
                });
                setBankReportListData(response?.data?.salary);
                setTotalPages(response?.data?.pagesNumber);

            }
            setSalaryReportTableUILoading(false)
        } catch {
            setSalaryReportTableUILoading(false)
        }
    }
    const fetchAllBankReportData = async () => {
        setLoadingAllSalaryReport(true);
        try {
            if (report_month) {
                // const url = currentRoute === "salary-wages-report" ? `/report/salary?month=${month}&year=${year}&order_type=ASC&dept_id=${deptId}`
                //     :
                //     currentRoute === "salary-report" ? `/report/salary?month=${month}&year=${year}&salary_type=salary&order_type=ASC&dept_id=${deptId}`
                //         :
                //         currentRoute === "wages-report" ? `/report/salary?month=${month}&year=${year}&salary_type=wages&order_type=ASC&dept_id=${deptId}`
                //             :
                //             `/report/salary?month=${month}&year=${year}&order_type=ASC&dept_id=${deptId}`

                const url= (paymentThrough=="ALL_EMP"||"")?`/report/bank_details?year=${year}&month=${month}&page=${currentPage+1}&limit=${rowsPerPage}&search=${searchQuery}`:
                `/report/bank_details?year=${year}&month=${month}&filter=${paymentThrough}`

                const response = await fetchData({
                    url: url,
                    method: 'GET',
                });
                setBankReportPDFData(response?.data?.salary);
                // extractAllowances(response?.data?.salary);
                setBankReportSummary(response?.data?.additional_details)
                setTotalEmployee(response?.data?.count)
                setOrganizationInfo(response?.data?.org_details)
                setBankReportFullData(response?.data)
								setDataFetched(true)
                logger.log(response, "salaryReportListData99")

            }
            setLoadingAllSalaryReport(false)
        } catch (error){
            setLoadingAllSalaryReport(false)
        }

    }
    // const fetchDepartmentList = async () => {
    //     try {
    //         const response = await fetchData({
    //             url: '/department',
    //             method: 'GET',
    //         });
    
    //         const formattedData = response?.data?.departments?.map(dept => ({
    //             id: dept.department_id,
    //             name: dept.deptName
    //         }));
    
    //         setDepartmentLists(prev => [
    //             { id: '', name: 'All Employee' },  
    //             { id: null, name: 'Unassigned Employee' },  
    //             ...(formattedData || [])
    //         ]);
    
    //     } catch (error) {
    //         logger.log(error, "Error fetching department list");
    //         setDepartmentLists([
    //             { id: '', name: 'All Employee' },  
    //             { id: null, name: 'Unassigned Employee' }
    //         ]); 
    //     }
    // };
    
    

    useEffect(() => {
        fetchAllBankReportEmpList();
        // fetchDepartmentList()
    }, [bankReportInputs, rowsPerPage, currentPage, searchQuery])
    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };
    logger.log(paymentThrough, "paymentThrough")
    return {
        bankReportListData,
        allowances,
        bankReportSummary,
        organizationInfo,
        bankReportInputs,
        handleChange,
        rowsPerPage,
        currentPage,
        totalPages,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        searchQuery,
        setSearchQuery,
        departmentLists,
        bankReportPDFData,
        fetchAllBankReportData,
        loadingAllSalaryReport,
        dataFetched,
        setDeptId,
        totalEmployee,
        setPaymentThrough,
        bankReportFullData,
        paymentThrough
    }
}

export default useBankDisbursmentReportService
